import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-success-dialog',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SuccessComponent implements OnInit {
  public email: string;
  public title: string;
  public subtitle: string;
  public message: string;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any) {
    if (data) {
      this.email = this.data.email;
      this.title = this.data.title;
      this.message = this.data.message;
      this.subtitle = this.data.subtitle;
    }
  }

  ngOnInit() {}
}
